"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.news = void 0;
exports.news = {
    news_title: "Лента",
    news_placeholderTitle: "Пока нет новостей",
    news_newsTabTitle: "Новости",
    news_helpTabTitle: "Справка",
    news_typeNews: "Новости",
    news_typeHelp: "Справочный материал",
    news_typeLaw: "Юридическая справка",
    news_upsertTitle: "Создание или редактирование статьи",
    news_upsertArticleTitle: "Заголовок статьи",
    news_upsertArticleType: "Тип статьи",
    news_upsertArticleImportant: "Важная статья",
    news_upsertArticleBody: "Содержимое статьи",
    news_upsertArticleImages: "Изображения",
    news_upsertPromoLabel: "Изображение в заголовке статьи",
    news_upsertImagesLabel: "Изображения в содержимом статьи",
    news_upsertAddImage: "Добавить изображение",
    news_pushSettingsHeader: "Настройка уведомлений",
    news_pushEnabled: "Уведомления разрешены",
    news_pushDisabled: "Уведомления запрещены",
    news_pushEnabledDescription: "Вы будете получать уведомления о новостях и акциях",
    news_pushDisabledDescription: "Вы не сможете получать уведомления о новостях и акциях",
    news_pushEnable: "Включить уведомления",
    news_pushTextLabel: "Текст push-уведомления",
};
//# sourceMappingURL=news.js.map